<template>
  <b-card class="w-100">
    <b-tabs @activate-tab="onActiveTabChange">
      <b-tab id="tab-left-1" title="เรื่องร้องทุกข์">
        <b-row>
          <div class="col-md-8">
            <h3>
              {{ complaintData.complaintCode }}
              <FastTrackIcon
                v-if="complaintData.fastTrackAllowance"
                :isMouCompany="complaintData.fastTrackAllowance.isMouCompany"
                :isAllowFastTrack="
                  complaintData.fastTrackAllowance.isAllowFastTrack
                "
              />
              -
              {{ complaintData.complaintDateStr }}
            </h3>
            <h4>
              {{ complaintData.levelDesc }} : {{ complaintData.statusDesc }} -
              {{ complaintData.createTrackingStr }}
            </h4>
            <div v-if="isExternalAgency()">
              <span>
                ช่องทางร้องเรียน : {{ complaintData.channelDescription }} ({{
                  complaintData.departmentSenderName
                }})
              </span>
            </div>
            <div v-else>
              <span>
                ช่องทางร้องเรียน : {{ complaintData.channelDescription }}
              </span>
            </div>
          </div>
          <div class="justify-content-end col-md-4">
            <a class="btn btn-primary m-1" @click="onComplaintFormClicked"
              ><feather-icon
                icon="PrinterIcon"
                class="mr-50"
              />บันทึกคำร้องทุกข์</a
            >

            <a
              v-if="isTerminateComplaint()"
              class="btn btn-danger m-1"
              @click="onComplaintFormCancelClicked"
              ><feather-icon
                icon="FileMinusIcon"
                class="mr-50"
              />พิมพ์บันทึกขอยุติเรื่องร้องทุกข์
            </a>

            <a
              v-if="complaintData.channelId === 75 && gccProcessLevel === 10"
              @click="onGccDetailClicked"
              class="btn btn-outline-warning m-1"
              ><feather-icon class="text-warning mr-50" icon="BellIcon" />
              <span class="text-warning">มีข้อมูลเพิ่มเติมจาก GCC </span>
            </a>
            <!-- <a
              v-else-if="complaintData.channelId === 75"
              disable
              class="btn btn-outline-secondary text-muted m-1"
              ><feather-icon class="text-secondary" icon="BellIcon" />
            </a> -->
          </div>
        </b-row>

        <b-card
          title="ข้อมูลผู้ร้องทุกข์/ผู้ดำเนินการ"
          body-border-variant="primary"
          body-class="rounded"
        >
          <b-col cols="12 mt-2">
            <b-list-group flush>
              <PersonDataDigital
                v-for="item in personals"
                :key="item.userId"
                :AllowDelete="IsAllowDelete_PersonDataDigital"
                :person="item"
                :IsReadOnly="IsReadOnly_PersonDataDigital"
                @handle-edit-personal="onPersonDigitalEditClicked"
              />
            </b-list-group>
          </b-col>

          <b-col cols="12 mt-2">
            ประสงค์ไกล่เกลี่ยออนไลน์ :
            {{ complaintData.mediate == true ? "ประสงค์" : "ไม่ประสงค์" }}
          </b-col>
        </b-card>

        <b-card
          title="ผู้มอบอำนาจ"
          body-border-variant="primary"
          body-class="rounded"
        >
          <b-col class="container text-right mt-n2"> </b-col>
          <b-col cols="12">
            <b-list-group flush>
              <PersonDataDigital
                v-for="item in attorneys"
                :key="item.userId"
                :AllowDelete="IsAllowDelete_PersonDataDigital"
                :person="item"
                :IsReadOnly="IsReadOnly_PersonDataDigital"
                @handle-edit-personal="onPersonDigitalEditClicked"
              />
            </b-list-group>
          </b-col>
        </b-card>

        <b-card
          title="ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)"
          body-border-variant="primary"
          body-class="rounded"
        >
          <b-col class="container text-right mt-n2"> </b-col>
          <b-col cols="12">
            <b-list-group flush>
              <b-list-group-item>
                <CompanyDetail
                  :edit="IsEdit_CompanyDetail"
                  :is-read-only="IsReadOnly_CompanyDetail"
                  :IsDeleteAble="IsDeleteAble_CompanyDetail"
                  :company="complaintData"
                />
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-card>

        <div
          v-if="
            complaintData.fastTrackAllowance &&
              this.ComponentName !== 'BangkokOfficerMange' &&
              this.ComponentName !== 'BangkokOfficerHistory'
          "
        >
          <FastTrackAllowance :data="complaintData.fastTrackAllowance" />
        </div>

        <b-card body-border-variant="primary" body-class="rounded">
          <h2 class="card text-center" style="color:Red;">
            ส่วนเจ้าหน้าที่กรอก
          </h2>
          <h5 class="card-title">ค้นหาผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)</h5>
          <b-col class="container text-right mt-n2">
            <b-button
              v-if="this.IsEdit_CompanySearch === true"
              variant="primary"
              @click="
                onBtnCompanySearchClicked({
                  compId: '',
                  companyDetail: '',
                  address: null,
                })
              "
            >
              <feather-icon icon="PlusIcon" class="mr-25" />
              <span>ค้นหาผู้ประกอบธุรกิจ</span>
            </b-button>
            <b-button
              v-if="
                this.IsEdit_CompanySearch === true &&
                  this.ComponentName !== 'ProvinceOfficerMange' &&
                  isAllowAddCompany() === true
              "
              variant="primary"
              class="ml-1"
              @click="onBtnCompanyModalClicked(null)"
            >
              <feather-icon icon="PlusIcon" class="mr-25" />
              <span>เพิ่มผู้ประกอบธุรกิจ</span>
            </b-button>
          </b-col>
          <b-col cols="12">
            <b-list-group flush>
              <b-list-group-item
                v-for="item in complainantCompany"
                :key="item.compId"
              >
                <CompanySearch
                  :company="item"
                  :IsEdit_CompanySearch="
                    IsEdit_CompanySearch && isAllowAddCompany() === true
                  "
                  :IsProvince_CompanySearch="
                    ComponentName === 'ProvinceOfficerMange'
                  "
                  @handle-edit="onBtnCompanyModalEditClicked"
                  @handle-delete="onBtnCompanySearchDeleteClicked"
                  @handle-attorney="onBtnCompanyModalAttorneyClicked"
                />
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-card>

        <b-card
          title="รายละเอียดเรื่องร้องทุกข์"
          body-border-variant="primary"
          body-class="rounded"
        >
          <ComplaintDetail
            ref="Step3Ref"
            :IsReadOnly="IsReadOnly_ComplaintDetail"
            :complaintDetail="complaintDetail"
            :complaintCatagoryDetail="complaintCatagoryDetail"
            :complaintDetailMultiSelect="complaintDetailMultiSelect"
            :company="complaintData"
            @checkboxChanged="checkboxChanged"
          />
        </b-card>
      </b-tab>

      <TabAttachFiles
        @handle-upload="onAttachFileUploaded"
        @handle-delete="onAttachFileDelete"
        @handle-tab-change="onSubActiveTabChange"
        :attachFiles="attachFiles"
        :attachFilesType2="attachFilesType2"
        :attachFileDate="attachFileDate"
        :attachFileDateType2="attachFileDateType2"
        :fileFormstatusModel="fileFormstatusType4Model"
        :fileFormstatusModelDates="fileFormstatusType4ModelDates"
        :IsEdit_TabAttachFiles="IsEdit_TabAttachFiles"
      />

      <TabDocumentTrackingDetail
        v-if="
          ComponentName !== 'BangkokOfficerMange' &&
            ComponentName !== 'BangkokOfficerHistory'
        "
        :complaintId="this.$route.query.id"
        :fileFormstatusModel="fileFormstatusType3Model"
        :fileFormstatusModelDates="fileFormstatusType3ModelDates"
      />

      <!-- <TabAttachFilesTrackingDoc
      @handle-upload="onAttachFileUploaded"
      @handle-delete="onAttachFileDelete"
      :attachFiles="attachFiles"
      :attachFileDate="attachFileDate"
      :IsEdit_TabAttachFiles="IsEdit_TabAttachFiles"
    /> -->
    </b-tabs>
    <b-col cols="12" class="">
      <!-- <b-button variant="secondary" @click="onComplaintBtnCancelClicked">
      ยกเลิก
    </b-button> -->
      <b-button
        style="float: right"
        v-if="
          (this.IsEditData === true || IsEdit_TabAttachFiles === true) &&
            showSubmitBtn === true &&
            ComponentName !== 'BangkokOfficerMange' &&
            ComponentName !== 'BangkokOfficerHistory'
        "
        variant="primary"
        @click="onComplaintBtnSubmitClicked"
      >
        บันทึกข้อมูล
      </b-button>
    </b-col>
    <ModalGcc ref="modalGccComponent" :gccObj="gccDetail" />

    <ModalDigitalIdAttorney
      ref="modalDigitalIdCompanyAttorneyComponent"
      :compId="currentCompIdAttorneyModal"
    />
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";

import CompanyDetail from "../components/CompanyDetail.vue";
import CompanySearch from "../components/CompanySearch.vue";
import RightTab from "../components/RightTabAction.vue";
import LeftTab from "../components/LeftTabAction.vue";

import TabAttachFiles from "../components/TabAttachFiles.vue";
import TabAttachFilesTrackingDoc from "../components/TabAttachFilesTrackingDoc.vue";
import TabDocumentTrackingDetail from "../components/TabDocumentTrackingDetail.vue";

import PersonDataDigital from "../components/PersonDataDigital.vue";
import ModalDigitalId from "../components/DigitalIdUserModal.vue";
import ModalCompany from "../components/ModalCompany.vue";
import ComplaintDetail from "../components/ComplaintDetail.vue";
import ModalGcc from "../components/ModalGcc.vue";
import FastTrackAllowance from "@/views/Complaint/components/FastTrack/FastTrackAllowance.vue";
import FastTrackIcon from "@/views/Complaint/components/FastTrack/FastTrackIcon.vue";

import * as viewStore from "@/store/api/screening/screeningManage.js";
import * as complaintStore from "@/store/api/complaint/complaint.js";
import * as userStore from "@/store/api/user/index.js";
import * as gccStore from "@/store/api/gcc/index.js";

import * as userData from "@/auth/localStorageUtils.js";
import appsettings from "@/store/app-settings";
import { props } from "vue-prism-component";

import ModalDigitalIdAttorney from "../components/DigitalIdCompanyAttorneyModal.vue";
export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BListGroup,
    BListGroupItem,
    BCardActions,
    RightTab,
    LeftTab,
    TabAttachFiles,
    TabDocumentTrackingDetail,
    viewStore,
    complaintStore,
    ModalDigitalId,
    ModalCompany,
    PersonDataDigital,
    CompanyDetail,
    CompanySearch,
    ComplaintDetail,
    userStore,
    TabAttachFilesTrackingDoc,
    ModalGcc,
    ModalDigitalIdAttorney,
    FastTrackAllowance,
    FastTrackIcon,
  },
  props: {
    complaintData: {},

    IsAllowDelete_PersonDataDigital: Boolean,
    IsReadOnly_PersonDataDigital: Boolean,
    personals: [],
    attorneys: [],

    IsEdit_CompanyDetail: Boolean,
    IsDeleteAble_CompanyDetail: Boolean,
    IsReadOnly_CompanyDetail: Boolean,

    IsEdit_CompanySearch: Boolean,

    complainantCompany: [],

    IsReadOnly_ComplaintDetail: Boolean,
    complaintDetail: {
      type: Array,
    },
    complaintCatagoryDetail: {
      type: Array,
      default: [],
    },
    complaintDetailMultiSelect: {
      type: Array,
      default: [],
    },
    company: {
      //ใช้ 2 Component
      type: Object,
      required: true,
    },

    IsEdit_TabAttachFiles: Boolean,
    attachFiles: [],
    attachFilesType2: [],
    attachFileDate: [],
    attachFileDateType2: [],
    fileFormstatusModel: [],
    fileFormstatusModelDates: [],
    fileFormstatusType3Model: [],
    fileFormstatusType3ModelDates: [],
    fileFormstatusType4Model: [],
    fileFormstatusType4ModelDates: [],
    IsEditData: Boolean,
    ComponentName: "",
    tabIndex: 0,
    subTabIndex: 0,
  },
  data() {
    return {
      showSubmitBtn: true,
      gccDetail: {
        rootobject: {},
      },
      gccProcessLevel: null,
      gccCaseId: null,
      currentCompIdAttorneyModal: null,
    };
  },
  watch: {
    complaintData: {
      handler() {
        const _this = this;
        console.log("channelId computed", this.complaintData.channelId);
        if (this.complaintData.channelId === 75) {
          // gcc1111
          gccStore
            .getComplaintGCClistlog(_this.complaintData.complaintId)
            .then((response) => {
              if (response.data.data.processlevel === 10) {
                _this.gccProcessLevel = response.data.data.processlevel;
                _this.gccCaseId = response.data.data.caseId;
                gccStore
                  .getApiById(_this.gccCaseId)
                  .then((response2) => {
                    _this.gccDetail = response2.data.data;
                  })
                  .catch((err) => {
                    console.log("err", err);
                  });
              }
            })
            .catch((error) => {});
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onGccDetailClicked() {
      console.log("modalGccComponent");
      this.$refs.modalGccComponent.$refs["modal-gcc"].show();
    },
    onComplaintFormClicked() {
      if (
        this.ComponentName === "BangkokOfficerMange" ||
        this.ComponentName === "BangkokOfficerHistory"
      ) {
        const url = appsettings.complaintFormUrlBangkok.replace(
          "{0}",
          this.$route.query.id,
        );
        window.open(url, "_blank");
      } else {
        const url = appsettings.complaintFormUrl.replace(
          "{0}",
          this.$route.query.id,
        );
        window.open(url, "_blank");
      }
    },
    onComplaintFormCancelClicked() {
      const url = appsettings.complaintFormCancelUrl.replace(
        "{0}",
        this.$route.query.id,
      );
      window.open(url, "_blank");
    },
    onComplaintBtnCancelClicked() {
      this.$emit("onComplaintBtnCancelClicked");
    },
    onComplaintBtnSubmitClicked() {
      const _this = this;

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const data = {
            complaintModel: this.complaintData,
            personals: this.personals,
            attorneys: this.attorneys,
            attachFiles: this.attachFiles,
            complainantCompany: this.complainantCompany,
            userId: userData.userId(),
            complaintDetail: this.complaintDetail,
            complaintDetailMultiSelect: this.complaintDetailMultiSelect,
            complaintCatagoryDetail: this.complaintCatagoryDetail,
          };

          complaintStore
            .updateComplaint(data)
            .then((response) => {
              console.log("response", response);

              _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                variant: "success",
                solid: false,
              });

              // window.open(
              //   this.$router.resolve({ name: "screening" }).href,
              //   "_self"
              // );

              this.$router.go(this.$router.currentRoute);
            })
            .catch((error) => {
              console.log("err", error);
            });

          //window.open(this.$router.resolve({ name: "screening" }).href, "_self");
        }
      });
    },

    //11
    onPersonDigitalEditClicked(passData) {
      this.$emit("onPersonDigitalEditClicked", passData);
    },

    //22
    onBtnCompanySearchDeleteClicked(passData) {
      console.log("onDeletedBtnClicked");
      this.$emit("onBtnCompanySearchDeleteClicked", passData);
    },
    onBtnCompanySearchClicked(passData) {
      console.log("onEditBtnClicked");
      this.$emit("onBtnCompanySearchClicked", passData);
    },
    onBtnCompanyModalEditClicked(passData) {
      this.onBtnCompanyModalClicked(passData.compId);
    },
    onBtnCompanyModalClicked(id) {
      console.log("onBtnCompanyModalClicked", id);
      this.$emit("company-digital-modal-clicked", id);
    },
    onBtnCompanyModalAttorneyClicked(passData) {
      this.onBtnCompanyModalAttorneyClickedEmit(passData.compId);
    },
    onBtnCompanyModalAttorneyClickedEmit(id) {
      console.log("onBtnCompanyModalAttorneyClickedEmit", id);
      this.currentCompIdAttorneyModal = id;
      this.$refs.modalDigitalIdCompanyAttorneyComponent.$refs[
        "modal-digital-id-company-attorney"
      ].show();
    },
    //33
    checkboxChanged(obj) {
      //console.log("checkboxChangedIn: ", obj)
      console.log("multiselectedChanged: ", this.complaintDetailMultiSelect);
      this.$emit("checkboxChanged", obj);
    },

    //tab2
    onAttachFileUploaded(file) {
      console.log("handleUpload:", file);
      this.$emit("onAttachFileUploaded", file);
    },
    onAttachFileDelete(id) {
      console.log("emitDeleteFile", id);
      this.$emit("onAttachFileDelete", id);
    },
    onActiveTabChange(newTabIndex) {
      this.tabIndex = newTabIndex;

      if (newTabIndex === 2) {
        this.showSubmitBtn = false;
      } else if (newTabIndex === 1) {
        if (this.subTabIndex === 1) {
          this.showSubmitBtn = false;
        } else {
          this.showSubmitBtn = true;
        }
      } else {
        this.showSubmitBtn = true;
      }
    },
    onSubActiveTabChange(newTabIndex) {
      console.log("onSubActiveTabChange", newTabIndex);
      this.subTabIndex = newTabIndex;
      this.onActiveTabChange(this.tabIndex);
    },
    isTerminateComplaint() {
      try {
        if (this.complaintData.terminateByUser === true) {
          console.log("termiante true");
          return true;
        }
        console.log("terminate flase");
        return false;
      } catch (ex) {
        console.log("terminate flase", ex);
        return false;
      }
    },
    isAllowAddCompany() {
      try {
        return true;
        if (
          userData.isAdminRole() ||
          appsettings.complaintRoleId.screening ===
            userData.selectedRole().toLowerCase()
        ) {
          return true;
        }

        return false;
      } catch (ex) {
        return false;
      }
    },
    isExternalAgency() {
      try {
        if (this.complaintData.channelId === 539) {
          return true;
        }
        return false;
      } catch (ex) {
        console.log("Error", ex);
        return false;
      }
    },
  },
};
</script>

<style scoped>
.fast-track-icon {
  max-height: 32px;
}
</style>
